import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static lists(postId) {
        return PostApiBase.composites({
            post_id: postId,
        }).then((resp) => {
            return resp.data["items"]
        })
    }
}
